/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const GET_POLICY_LIST = gql`
query GetListOfPayout($input: GetListOfPayoutsInput) {
  getListOfPayout(input: $input) {
    data {
      id
      policyNumber
      policyId
      purchaser {
        email
        firstName
        lastName
        image
        vuid
        address {
          addressLine1
          city
          country
        }
        occupation
        bio
        primaryContactNo
      bankDetails {
        accHolderName
        accountNo
        bankName
        swiftCode
        type
        vuid
      }
      }
      cyclone {
        status
        eventId
        stormName
        category
      }
      amount
      amountRaw
      status
      paidOn
      policy {
        coverage
        policyNumber
        premium
        purchasedAt
        productDefination
        countryToBeInsured
      }
    }
    currentPage
    pageSize
    totalCount
    totalPages
  }
}
`;
